module.exports = __webpack_public_path__ + "static/img/base_map.9289ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapFragment/base_map.png
// module id = F6Lq
// module chunks = 3